import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from './base/Icon';
import type { BaseIconProps } from './types';
type ClaudeProps = BaseIconProps;
const Claude: React.FC<ClaudeProps> = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    width,
    height,
    color: t2
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const color = t2 === undefined ? "#D97757" : t2;
  const iconWidth = width || size;
  const iconHeight = height || size;
  let t3;
  if ($[0] !== color) {
    t3 = <Path d="M32 2 L34.5 26 L58.5 22 L37.6 33.4 L58.5 42 L34.5 38 L32 62 L29.5 38 L5.5 42 L26.4 30.6 L5.5 22 L29.5 26 Z" fill={color} />;
    $[0] = color;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== iconHeight || $[3] !== iconWidth || $[4] !== t3) {
    t4 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 64 64" fill="none">{t3}</Icon>;
    $[2] = iconHeight;
    $[3] = iconWidth;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default Claude;